export default __webpack_public_path__ + "static/media/mb6.1c43d3af.jpg";